//import logo from './logo.svg';
//import 'bootstrap/dist/css/bootstrap.min.css';
import React,{useState, useEffect} from 'react';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import './App.css';
import Home from './pages/home';
import Single from './pages/single';
import Spread from './pages/spread';
import Cards from './pages/cards';
import Saved from './pages/saved';
import { Navbar, Nav, Container, Tab} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faTablet, faStream, faTh, faFeather, faDiceD20 } from '@fortawesome/free-solid-svg-icons';
import ParticleMotion from './pages/particles';
import { SplashScreen } from '@capacitor/splash-screen';
import { isBrowser, isMobileSafari, isMobile, isIOS, isTablet} from 'react-device-detect';
import { App } from '@capacitor/app';
import { useLanguage } from './i18n/LanguageContext';

function GHCApp() {
  const { t } = useLanguage();
  const [refreshCount, refresh] = useState(0);
  const [stopped, setStop] = useState(false);
  const [bgType, setBgType] = useState("starconnect");

  const clearZoom = () => {

    //if (isIOS){ //iOS only anyway
      if (window.innerHeight != window.outerHeight){
        const viewport = document.querySelector('meta[name="viewport"]');

        if ( viewport ) {
          viewport.content = 'maximum-scale=1, viewport-fit=cover';
          setTimeout(function(){
            viewport.content = 'width=device-width, maximum-scale=10, viewport-fit=cover';
          },100)
        }
      }
    //}
  }

  useEffect(() => {
     // Hide the splash (you should do this on app launch)
     setTimeout(function(){
      SplashScreen.hide();
      if (isMobile && !isTablet){
        window.screen.orientation.lock('portrait');
      }
     },1500);

     App.addListener('appStateChange', ({ isActive }) => {
      setStop(!isActive);
    });
    
     if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", clearZoom);
      }
      else{
        window.addEventListener("orientationchange", clearZoom);
      }
    }
    else{
      window.addEventListener("resize", clearZoom);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", clearZoom);
        }
        else{
          window.removeEventListener("orientationchange", clearZoom);
        }
      }
      else{
        window.removeEventListener("resize", clearZoom);
      }
    } 
  },[] );

  function handleSelect(key){
    //window.scrollTo(0,0);

    if (key == "saved"){
      var newCount = refreshCount + 1;
      refresh(newCount);
      //setStop(true);
    }
    else if(key == "cards"){
      //setStop(true);
    }
    else{
      //setStop(false);
    }
   
  }

  function onSubSelect(){
    //clearZoom();
  }

  function onBgSelect(key){
    setBgType(key);
  }

  function getTabs(){
   
      return (<Tab.Container fixed="bottom" defaultActiveKey="home">
          <Nav variant="pills" className='fixed-bottom navbar-expand' fill style={{ backgroundColor: '#212529'}} onSelect={handleSelect} >
          <Nav.Link eventKey="home">
              <div>
              {/*sm, md, lg,1x and 2x*/}
              <FontAwesomeIcon icon={faDiceD20}  size='2x' />
                <div className="bottom-tab-label">{t('tabs.guide')}</div>
              </div>
            </Nav.Link>
            <Nav.Link eventKey="single">
              <div>
              {/*sm, md, lg,1x and 2x*/}
              <FontAwesomeIcon icon={faTablet}  size='2x'  />
                <div className="bottom-tab-label">{t('tabs.single')}</div>
              </div>
            </Nav.Link>
            <Nav.Link eventKey="spread" >
            <div>
              {/*sm, md, lg,1x and 2x*/}
              <FontAwesomeIcon icon={faStream}  size='2x'  />
                <div className="bottom-tab-label">{t('tabs.spread')}</div>
              </div>
            </Nav.Link>
            <Nav.Link eventKey="cards">
            <div>
              {/*sm, md, lg,1x and 2x*/}
              <FontAwesomeIcon icon={faTh} size='2x'  />
                <div className="bottom-tab-label">{t('tabs.cards')}</div>
              </div>
            </Nav.Link>
            <Nav.Link eventKey="saved">
            <div>
              {/*sm, md, lg,1x and 2x*/}
              <FontAwesomeIcon icon={faFeather} size='2x' />
                <div className="bottom-tab-label">{t('tabs.saved')}</div>
              </div>
            </Nav.Link>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="home">
              <Home theme={theme} onBgSelect={onBgSelect} onSubSelect={onSubSelect}></Home>
            </Tab.Pane>
            <Tab.Pane eventKey="single">
              <Single theme={theme}></Single>
            </Tab.Pane>
            <Tab.Pane eventKey="spread">
              <Spread theme={theme} onSubSelect={onSubSelect}></Spread>
            </Tab.Pane>
            <Tab.Pane eventKey="cards">
              <Cards theme={theme} onSubSelect={onSubSelect}></Cards>
            </Tab.Pane>
            <Tab.Pane eventKey="saved">
            <Saved theme={theme} refresh={refreshCount} onSubSelect={onSubSelect}></Saved>
            </Tab.Pane>
          </Tab.Content>
      </Tab.Container>)
    
  }

  var theme = "dark";
  return (
    <div style={{overflow:'hidden'}}>
       <ParticleMotion stopped={stopped} theme={theme} bgType={bgType}/>
       {getTabs()}
    </div>
  );
}

export default GHCApp;